<script>
    export let data = {};

    const getDateString = timestamp => {
        timestamp = parseInt( `${timestamp}000` );
        return new Date(timestamp).toLocaleString();
    }
</script>

<div class="build-grid">
    {#if data.omaha}
        {#each Object.entries(data.omaha.channels) as [channel, builds]}
            <section class="build-box {channel}">
                <div class="build-box-header">
                    <h1>{channel}</h1>
                    {#if channel === 'release'}
                        <img src="brave.png" alt="" />
                    {:else}
                        <img src="brave_{channel}.png" alt="" />
                    {/if}
                    <h3>{builds[0].build}</h3>
                    <p>{getDateString(builds[0].date)}</p>
                </div>
                <ul>
                    {#each data.github.channels[channel] as tag, index}
                        <li class={tag.build === builds[0].build ? 'on' : 'off'}>
                            {tag.build} 
                            {#if tag.size > 0}
                                {#if data.github.channels[channel][index+1]?.size }
                                    ({ ((tag.size - data.github.channels[channel][index+1].size) / 1024 / 1024).toFixed(2) } MB)
                                {/if}
                            {/if}
                        </li>
                    {/each}
                </ul>
            </section>
        {/each}
    {/if}
</div>

<style>
    img {
        filter: drop-shadow(0 10px 5px rgba(0,0,0,.25));
    }
    .release {
        color: white;
        background: #ff3900;
    }

    .beta {
        background: #f2f2f2;
    }

    .dev {
        color: white;
        background: #0057b8;
    }

    .nightly {
        color: white;
        background: #7a27b6;
    }

    .build-grid {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;
    }
    .build-box {
        padding: 1em 2em;
        border-radius: 1em;
    }
    .build-box-header {
        text-align: center;
    }
    .on {
        opacity: 1;
        font-weight: bold;
    }
    .off {
        opacity: .75;
    }
</style>